import axios from '@/lib/AxApi';

export default {
  getUsersByCompanyId(params, cb)
  {
    params.onlyActive = 1;
    axios.get('/rest/User_data/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  resetPassword(params, cb)
  {
    axios.post('/rest/User/resetPassword', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  confirmPassword(params, cb)
  {
    axios.post('/rest/User/confirmPassword', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js